export const SubItems = ({ items }: { items: string[] }) => (
  <ul className="pl-7">
    {items.map((item, index) => (
      <li key={index} className="py-3">
        {item}
      </li>
    ))}
  </ul>
);
